module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Site Page Home */

(function(fox) {
	fox.registerWidget('SitePage_404', {

		// running: function() {
		// 	// this.handleEvent(, 'addedToDom', fox.bind(function() {
		// 		$('p.p3').text('The requested URL ' + location.hash + ' was not found on this server.');	
		// 	// }, this));
		// }
	
	}, 'Site_Page');
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/sitepage/404.js
// module id = 887
// module chunks = 4